import type { PlatformSupportReasonId } from "../../functions/src/api/constants";

/** Greek reason labels — shared with `platform-support-strings.ts` and support emails (no React). */
export const platformSupportReasonOptionsEl: Record<PlatformSupportReasonId, string> = {
    technical: "Τεχνικό πρόβλημα με την ιστοσελίδα / εφαρμογή",
    signIn: "Σύνδεση / πρόσβαση στον λογαριασμό",
    payment: "Πληρωμές / πορτοφόλι",
    ordersPackages: "Παραγγελίες ή πακέτα στην εφαρμογή",
    other: "Άλλο",
};

/** English labels for admin / ops (order app strings use Greek). */
export const platformSupportReasonOptionsEn: Record<PlatformSupportReasonId, string> = {
    technical: "Technical issue with the website / app",
    signIn: "Sign-in / account access",
    payment: "Payments / wallet",
    ordersPackages: "Orders or packages in the app",
    other: "Other",
};
